<template>
    <div>
        <v-form>
            <v-textarea
                v-model="model.msg"
                data-vv-name="comment"
                :error-messages="errors.collect('comment')"
                v-validate="'required'"
                dense
                outlined
                hide-details="auto"
                rows="3"
            ></v-textarea>
        </v-form>
        <btns-wrap
            class="mt-3"
        >
            <v-btn
                color="secondary"
                :small="!isMobile"
                @click="closeForm()"
                :style="{
                    'color': colorPrimary
                }"
                elevation="0"
            >{{ $t('msg.cancel') }}</v-btn>
            <v-btn
                color="primary"
                class="ml-2"
                :small="!isMobile"
                @click="sendForm()"
                elevation="0"
            >{{ $t('msg.send') }}</v-btn>
        </btns-wrap>
    </div>
</template>

<script>
import BtnsWrap from "../../ui/BtnsWrap";

export default {
    components: {BtnsWrap},
    props: {
        targetId: Number,
        targetDairyId: Number
    },
    data() {
        return {
            model: {
                id: null,
                msg: null
            }
        };
    },
    computed: {
        colorPrimary() {
            return process.env.VUE_APP_COLOR_PRIMARY_DARK;
        }
    },
    methods: {
        closeForm() {
            this.$emit('close-form');
        },
        sendForm() {
            this.$validator.validateAll().then(res => {
                if (res) {
                    let isCreate = this.model.id === null;
                    let action = isCreate ? 'createTargetDairyComments' : 'updateTargetDairyComments';

                    this.model.time_zone = this.$store.state.user.timeZone;

                    this.$store.dispatch(action, {
                        id: this.targetId,
                        subId: this.targetDairyId,
                        subSubId: this.model.id,
                        data: this.model,
                        formErrors: this.errors,
                    })
                        .then(res => {
                            this.model = res;
                            if (isCreate) this.$emit('created', this.model);
                            else this.$emit('updated', this.model);
                        });
                }
            });
        }
    }
}
</script>